import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Utilities } from '../../shared/utilities';
import { Plan } from '../../shared/classes/plan';
import { PlanService } from '../../shared/services/plan.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { UserService } from '../../shared/services/user.service';
import { Settings } from '../../shared/settings';

@Component({
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css']
})

export class PricingComponent implements OnInit, OnDestroy {

  public loading = true;
  public plans: Plan[] = [];
  public error = '';
  public message = '';
  public processing = false;
  public version = Settings.version;
  public environmentSettingsFile = Settings.environmentSettingsFile;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private planService: PlanService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy(): void {
  }

  loadData(): void {
    const that = this;
    that.loading = true;
    that.plans = [];
    forkJoin([
      that.planService.getActivePlans(),
      that.userService.getUserSubscriptions(this.userIsLoggedIn())
    ]).subscribe(([getActivePlansResponse, getUserSubscriptionsResponse]) => {
        if (getActivePlansResponse) {
          if (!getActivePlansResponse.HasError && getActivePlansResponse.Planes) {
            getActivePlansResponse.Planes.forEach(onePlan => that.plans.push(Plan.parse(onePlan)));
          } else {
            if (getActivePlansResponse.ErrorMessage){
              that.error = `<p><b>¡Error!</b></p><p>${getActivePlansResponse.ErrorMessage}</p>`;
            } else {
              that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
            }
          }
        } else {
          that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
        }
        if (getUserSubscriptionsResponse) {
          if (!getUserSubscriptionsResponse.HasError && getUserSubscriptionsResponse.Suscripciones) {
            // Por cada Id de plan que tiene el usuario, busco el plan y le seteo la property LoggedInUserHasPlan en true
            getUserSubscriptionsResponse.Suscripciones.forEach(
              oneUserSubscription => {
                const plan = that.plans.find(
                  onePlan =>
                    onePlan.PlanId === oneUserSubscription.SuscripcionPlanId &&
                    (oneUserSubscription.SuscripcionEstado === 'ACTIVA' || oneUserSubscription.SuscripcionEstado === 'VIGENTE')
                );
                if (plan) {
                  plan.LoggedInUserHasPlan = true;
                }
              }
            );
          } else {
            if (getUserSubscriptionsResponse.ErrorMessage){
              that.error = `<p><b>¡Error!</b></p><p>${getUserSubscriptionsResponse.ErrorMessage}</p>`;
            } else {
              that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
            }
          }
        } else {
          that.error = '<p>Ha ocurrido un error, por favor, intente nuevamente.</p>';
        }

        that.loading = false;
      },
      (error) => {
        Utilities.logError('Error al cargar los planes activos');
        Utilities.logError(error);
        that.loading = false;
        that.error = '<p><b>Ha ocurrido un error.</b></p><p>Por favor, intente nuevamente.</p>';
      });
  }

  public userIsLoggedIn(): boolean {
    return this.authenticationService.userIsLoggedIn();
  }

  public subscribeToPlan(planId: string): void {
    const navigationExtras: NavigationExtras = {
      queryParams: {planId}
    };
    this.router.navigate(['confirmacion-de-suscripcion'], navigationExtras);
  }

  public goTo(url): void {
    this.router.navigate([url]);
  }
}
